"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "react-i18next";
import { formatIssueDate } from "@/shared/lib/format/dates";
import { formatUzsValue } from "@/shared/lib/format/numbers";
import { cn } from "@/shared/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/ui/tooltip";
export type ReferentPriceCellTone = "over" | "near" | "default";
type ReferentPriceCellProps = {
  value: number | null;
  capturedAt: string | null;
  intlLocale: string;
  tone?: ReferentPriceCellTone;
  hideDecimals?: boolean;
};
export function ReferentPriceCell(t0) {
  const $ = _c(32);
  const {
    value,
    capturedAt,
    intlLocale,
    tone: t1,
    hideDecimals: t2
  } = t0;
  const tone = t1 === undefined ? "default" : t1;
  const hideDecimals = t2 === undefined ? false : t2;
  const {
    t
  } = useTranslation();
  let t3;
  if ($[0] !== hideDecimals || $[1] !== value) {
    t3 = formatUzsValue(value, {
      noDecimals: hideDecimals
    });
    $[0] = hideDecimals;
    $[1] = value;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const formatted = t3;
  let T0;
  let T1;
  let t4;
  let t5;
  let t6;
  let tooltipText;
  if ($[3] !== capturedAt || $[4] !== formatted || $[5] !== intlLocale || $[6] !== t || $[7] !== tone || $[8] !== value) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const className = cn("tabular-nums", tone === "over" && "text-rose-700 font-medium dark:text-rose-300", tone === "near" && "text-amber-700 font-medium dark:text-amber-300", tone === "default" && "text-muted-foreground");
      if (value == null || !capturedAt) {
        t6 = <span className={className}>{formatted}</span>;
        break bb0;
      }
      let t7;
      if ($[15] !== capturedAt || $[16] !== intlLocale || $[17] !== t) {
        t7 = t("wholesaleOffers.referentPriceCapturedOn", {
          date: formatIssueDate(capturedAt, intlLocale)
        });
        $[15] = capturedAt;
        $[16] = intlLocale;
        $[17] = t;
        $[18] = t7;
      } else {
        t7 = $[18];
      }
      tooltipText = t7;
      T1 = Tooltip;
      T0 = TooltipTrigger;
      t5 = true;
      t4 = cn(className, "cursor-help");
    }
    $[3] = capturedAt;
    $[4] = formatted;
    $[5] = intlLocale;
    $[6] = t;
    $[7] = tone;
    $[8] = value;
    $[9] = T0;
    $[10] = T1;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = tooltipText;
  } else {
    T0 = $[9];
    T1 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    tooltipText = $[14];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[19] !== formatted || $[20] !== t4) {
    t7 = <span className={t4}>{formatted}</span>;
    $[19] = formatted;
    $[20] = t4;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== T0 || $[23] !== t5 || $[24] !== t7) {
    t8 = <T0 asChild={t5}>{t7}</T0>;
    $[22] = T0;
    $[23] = t5;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== tooltipText) {
    t9 = <TooltipContent>{tooltipText}</TooltipContent>;
    $[26] = tooltipText;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== T1 || $[29] !== t8 || $[30] !== t9) {
    t10 = <T1>{t8}{t9}</T1>;
    $[28] = T1;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
}